document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pgs').forEach(initGallerySlider);
});

// Support Shopify theme editor re-renders
document.addEventListener('shopify:section:load', function (e) {
  const section = e.target.querySelector('.pgs');
  if (section) initGallerySlider(section);
});

function initGallerySlider(root) {
  if (root.dataset.pgsInit) return;
  root.dataset.pgsInit = 'true';

  const track = root.querySelector('.pgs__track');
  const prevBtn = root.querySelector('.pgs__nav--prev');
  const nextBtn = root.querySelector('.pgs__nav--next');
  const slides = Array.from(root.querySelectorAll('.pgs__slide'));
  if (!track || slides.length === 0) return;

  const autoplay = root.dataset.autoplay === 'true';
  const speed = parseInt(root.dataset.speed, 10) || 4000;
  let timer = null;
  let isPointerDown = false;

  function slideStep() {
    return slides[0].getBoundingClientRect().width + 16;
  }

  function atEnd() {
    return Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth;
  }

  function scrollNext() {
    if (atEnd()) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: slideStep(), behavior: 'smooth' });
    }
  }

  function scrollPrev() {
    track.scrollBy({ left: -slideStep(), behavior: 'smooth' });
  }

  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    timer = setInterval(scrollNext, speed);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  if (nextBtn) nextBtn.addEventListener('click', function () {
    scrollNext();
    startAutoplay();
  });
  if (prevBtn) prevBtn.addEventListener('click', function () {
    scrollPrev();
    startAutoplay();
  });

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', function () {
    if (!isPointerDown) startAutoplay();
  });
  track.addEventListener('pointerdown', function () {
    isPointerDown = true;
    stopAutoplay();
  });
  track.addEventListener('pointerup', function () {
    isPointerDown = false;
    startAutoplay();
  });

  // mouse-tracking glow position per card
  root.querySelectorAll('.pgs__card').forEach(function (card) {
    card.addEventListener('pointermove', function (e) {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--mx', x + '%');
      card.style.setProperty('--my', y + '%');
    });
  });

  startAutoplay();
}
